// extracted by mini-css-extract-plugin
export default {"wrapper":"MatchingModal_wrapper__tuNnV","body":"MatchingModal_body__ht9Zf"};